var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mobile-container" },
    [
      _c("IONotifications"),
      _vm._v(" "),
      _c("div", { staticClass: "top_menu" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body flex justify-content-end" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                on: {
                  click: function ($event) {
                    return _vm.mixinGoToRouter("TabletMyOrders")
                  },
                },
              },
              [_vm._v("Заявки")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                on: {
                  click: function ($event) {
                    return _vm.mixinGoToRouter("TabletMap")
                  },
                },
              },
              [_vm._v("Карта")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                on: {
                  click: function ($event) {
                    return _vm.mixinGoToRouter("TabletRequests")
                  },
                },
              },
              [
                _vm._v("Уведомления "),
                _c("span", { staticClass: "hidden badge badge-info" }, [
                  _vm._v("10"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                on: {
                  click: function ($event) {
                    return _vm.mixinGoToRouter("TabletReport")
                  },
                },
              },
              [_vm._v("Отчет")]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-container" }, [_c("router-view")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }